/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { WebComponentDTO } from '../models/web-component-dto';

/**
 * Ui Web Component Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiWebComponentControllerService extends __BaseService {
  static readonly getAllComponentsUsingGETPath = '/cc-ui/v1/web-components';
  static readonly createComponentUsingPOSTPath = '/cc-ui/v1/web-components';
  static readonly getComponentUsingGETPath =
    '/cc-ui/v1/web-components/{webComponentId}';
  static readonly updateComponentUsingPUTPath =
    '/cc-ui/v1/web-components/{webComponentId}';
  static readonly deleteComponentUsingDELETEPath =
    '/cc-ui/v1/web-components/{webComponentId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllComponents
   * @return OK
   */
  getAllComponentsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<WebComponentDTO>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/web-components`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WebComponentDTO>>;
      }),
    );
  }
  /**
   * getAllComponents
   * @return OK
   */
  getAllComponentsUsingGET(): __Observable<Array<WebComponentDTO>> {
    return this.getAllComponentsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<WebComponentDTO>),
    );
  }

  /**
   * createComponent
   * @param component component
   * @return OK
   */
  createComponentUsingPOSTResponse(
    component: WebComponentDTO,
  ): __Observable<__StrictHttpResponse<WebComponentDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = component;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/web-components`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebComponentDTO>;
      }),
    );
  }
  /**
   * createComponent
   * @param component component
   * @return OK
   */
  createComponentUsingPOST(
    component: WebComponentDTO,
  ): __Observable<WebComponentDTO> {
    return this.createComponentUsingPOSTResponse(component).pipe(
      __map((_r) => _r.body as WebComponentDTO),
    );
  }

  /**
   * getComponent
   * @param webComponentId webComponentId
   * @return OK
   */
  getComponentUsingGETResponse(
    webComponentId: string,
  ): __Observable<__StrictHttpResponse<WebComponentDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/web-components/${encodeURIComponent(
          String(webComponentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebComponentDTO>;
      }),
    );
  }
  /**
   * getComponent
   * @param webComponentId webComponentId
   * @return OK
   */
  getComponentUsingGET(webComponentId: string): __Observable<WebComponentDTO> {
    return this.getComponentUsingGETResponse(webComponentId).pipe(
      __map((_r) => _r.body as WebComponentDTO),
    );
  }

  /**
   * updateComponent
   * @param params The `UiWebComponentControllerService.UpdateComponentUsingPUTParams` containing the following parameters:
   *
   * - `webComponentId`: webComponentId
   *
   * - `component`: component
   *
   * @return OK
   */
  updateComponentUsingPUTResponse(
    params: UiWebComponentControllerService.UpdateComponentUsingPUTParams,
  ): __Observable<__StrictHttpResponse<WebComponentDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.component;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/web-components/${encodeURIComponent(
          String(params.webComponentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebComponentDTO>;
      }),
    );
  }
  /**
   * updateComponent
   * @param params The `UiWebComponentControllerService.UpdateComponentUsingPUTParams` containing the following parameters:
   *
   * - `webComponentId`: webComponentId
   *
   * - `component`: component
   *
   * @return OK
   */
  updateComponentUsingPUT(
    params: UiWebComponentControllerService.UpdateComponentUsingPUTParams,
  ): __Observable<WebComponentDTO> {
    return this.updateComponentUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as WebComponentDTO),
    );
  }

  /**
   * deleteComponent
   * @param webComponentId webComponentId
   */
  deleteComponentUsingDELETEResponse(
    webComponentId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/web-components/${encodeURIComponent(
          String(webComponentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteComponent
   * @param webComponentId webComponentId
   */
  deleteComponentUsingDELETE(webComponentId: string): __Observable<null> {
    return this.deleteComponentUsingDELETEResponse(webComponentId).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiWebComponentControllerService {
  /**
   * Parameters for updateComponentUsingPUT
   */
  export interface UpdateComponentUsingPUTParams {
    /**
     * webComponentId
     */
    webComponentId: string;

    /**
     * component
     */
    component: WebComponentDTO;
  }
}

export { UiWebComponentControllerService };
